// Constants
const SELECTORS = {
  CART_LOADER: ".js-cart-loader",
  CART_LOADER_TEXT: ".js-cart-loader-text",
  SAVED_CARTS_CONTAINER: ".js-saved-carts-container"
};

export default class MastheadCartDropdownLoader {
  constructor({
    loaderSelector = SELECTORS.CART_LOADER,
    textSelector = SELECTORS.CART_LOADER_TEXT,
    containerSelector = SELECTORS.SAVED_CARTS_CONTAINER
  } = {}) {
    this.loaderSelector = loaderSelector;
    this.textSelector = textSelector;
    this.containerSelector = containerSelector;
  }

  // Getters
  $getCartLoader = () => document.querySelector(this.loaderSelector);

  $getCartLoaderText = () => document.querySelector(this.textSelector);

  $getSavedCartsContainer = () => document.querySelector(this.containerSelector);

  // Setters
  show(message) {
    const $cartLoader = this.$getCartLoader();
    const $cartLoaderText = this.$getCartLoaderText();
    const $savedCartsContainer = this.$getSavedCartsContainer();

    if ($cartLoaderText) {
      $cartLoaderText.textContent = message;
    }
    if ($cartLoader) {
      $cartLoader.classList.remove("hidden");
    }
    if ($savedCartsContainer) {
      $savedCartsContainer.classList.add("hidden");
    }
  }

  hide() {
    const $cartLoader = this.$getCartLoader();
    const $savedCartsContainer = this.$getSavedCartsContainer();

    if ($cartLoader) {
      $cartLoader.classList.add("hidden");
    }
    if ($savedCartsContainer) {
      $savedCartsContainer.classList.remove("hidden");
    }
  }

  // Actions
  async executeWithLoader(loaderMessage, apiAction) {
    // Store current content before showing loader
    const $savedCartsContainer = this.$getSavedCartsContainer();
    const previousContent = $savedCartsContainer ? $savedCartsContainer.innerHTML : "";

    this.show(loaderMessage);

    try {
      await apiAction();
    } catch (error) {
      console.error(`Failed: ${loaderMessage}`, error);
      // Restore previous content (old list)
      this.hide();
      if ($savedCartsContainer && previousContent) {
        $savedCartsContainer.innerHTML = previousContent;
        // Re-initialize cart items after restore
        const initEvent = new CustomEvent("cart:items:reinit");
        document.dispatchEvent(initEvent);
      }
    }
  }
}
